import { Component } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { SomeNavigationService, AuthSessionInterceptorService, BusinessStagnationResponseService } from 'cbc-shared-lib';
import { AuthService } from 'cbc-shared-lib';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { ToastMessageService } from 'cbc-shared-lib';
import { MakeIconService, ButtonStateService } from 'sg-features';

/**
 * ルートモジュールのメインコンポーネント
 * @export
 * @class AppComponent
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'kcis';

  constructor(private location: LocationStrategy,
    private someNavigationService: SomeNavigationService,
    private router: Router,
    private authService: AuthService,
    private toast: ToastMessageService,
    private makeIconService: MakeIconService,
    private authSessionInterceptorService: AuthSessionInterceptorService,
    private businessStagnationResponseService: BusinessStagnationResponseService,
    private buttonStateService: ButtonStateService
  ) {
    // ブラウザの戻るボタン押下を監視する
    this.location.onPopState(() => {
      this.someNavigationService.backClicked = true;
      return false;
    });

    // 500エラーの発生を監視する
    this.authSessionInterceptorService.error$.subscribe(() => {
      this.router.navigate(['/sgkz002d']);
    });

    // 業務閉塞エラーの発生を監視する
    this.businessStagnationResponseService.error$.subscribe(() => {
      this.router.navigate(['/sgkz006d']);
    });

    // サイドメニュー：2階層以降の選択ボタンの表示を初期化する
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/sgkz001d') {
          this.buttonStateService.selectButton(null);
        }
      }
    });

    // ログイン処理(URL直打ち対応)
    if (this.authService.isAuthenticated()) {
      this.authService.tryLogin().subscribe(
        _ => {
          // ログイン試行の結果認証トークンがあれば初期処理実行
          if (this.authService.isAuthenticated()) {
            this.authService.autoUpdateToken();
          }
        },
      );
    }

    // Routerで遷移時の処理
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // トーストメッセージをクリア
        this.toast.clear();
      }
    })

    this.makeIconService.makeIcon();
  }
}
